/**
 * @returns {RegExp}
 */
function ssn () {
  return /(0[1-9]|1\d|2\d|30|31)(0[1-9]|10|11|12)(\d{2})(\d{5})$/
}

module.exports = { ssn }
